module.exports = __webpack_public_path__ + "static/img/content_bg.38efb5dc.png";